import { assoc, prop } from 'ramda';
import def from './define-action';

const INITIAL_STATE = {
    poiClick: false,
    labelClick: false,
    noteClick: false,
    isAddMode: false,
    movePoiMode: '',
};

// =====================================================================================================================
// Action Constants
// =====================================================================================================================

const ActionConstants = {
    ADD_LABEL_MODE: 'ADD_LABEL_MODE',
    ADD_NOTE_MODE: 'ADD_NOTE_MODE',
    ADD_POI_MODE: 'ADD_POI_MODE',
    CLEAR_MODE: 'CLEAR_MODE',
    CHANGE_ADD_MODE: 'CHANGE_ADD_MODE',
    CHANGE_MOVE_POI_MODE: 'CHANGE_MOVE_POI_MODE',
};

// =====================================================================================================================
// Actions
// =====================================================================================================================

const Actions = {
    addLabelClick: def(ActionConstants.ADD_LABEL_MODE),
    addNoteClick: def(ActionConstants.ADD_NOTE_MODE),
    addPoiClick: def(ActionConstants.ADD_POI_MODE),
    clearMode: def(ActionConstants.CLEAR_MODE),
    changeAddMode: def(ActionConstants.CHANGE_ADD_MODE, 'isAddMode'),
    changeMovePoiMode: def(ActionConstants.CHANGE_MOVE_POI_MODE, 'movePoiMode'),
};

// =====================================================================================================================
// Reducer
// =====================================================================================================================

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ActionConstants.ADD_POI_MODE:
            return handleAddPoiMode(state);
        case ActionConstants.ADD_LABEL_MODE:
            return handleAddLabelMode(state);
        case ActionConstants.ADD_NOTE_MODE:
            return handleAddNoteMode(state);
        case ActionConstants.CLEAR_MODE:
            return handleClearMode(state);
        case ActionConstants.CHANGE_ADD_MODE:
            return handleChangeAddMode(state, action);
        case ActionConstants.CHANGE_MOVE_POI_MODE:
            return handleChangeMovePoiMode(state, action);
        default:
            return state;
    }
};

const handleAddPoiMode = state => ({ ...state, poiClick: true, labelClick: false, noteClick: false });
const handleAddLabelMode = state => ({ ...state, poiClick: false, labelClick: true, noteClick: false });
const handleAddNoteMode = state => ({ ...state, poiClick: false, labelClick: false, noteClick: true });
const handleClearMode = state => ({ ...state, poiClick: false, labelClick: false, noteClick: false });
const handleChangeAddMode = (state, action) => assoc('isAddMode', action.isAddMode, state);
const handleChangeMovePoiMode = (state, action) => assoc('movePoiMode', action.movePoiMode, state);

// =====================================================================================================================
// Selectors
// =====================================================================================================================

const getMode = masterState => prop('mode', masterState);

const Selectors = { getMode };

export default reducer;

export { reducer, Actions, Selectors };
